function scrollToId(ID) {
    setTimeout(() => {
        const el = document.getElementById(ID);
        if (el) {
            el.scrollIntoView({ block: 'start', behavior: 'smooth' });
            const scrolledY = window.scrollY;
            if (scrolledY) {
                window.scroll(0, scrolledY - 50);
            }
        }
    }, 500);
}
export default scrollToId;
